import React from "react";
import { Button, Alert } from 'antd';
import config from '../../config.json'

class errorPage extends React.Component {

  constructor(props) {
    super(props);
     this.state = {
         details:this.props.details,
         alertMessage:"Error: Please retry later. If the error persists, contact the admin."
     }  
}
loginAgain(){
  window.location.href=config.loginPage;
}

render() {

    const details = this.state.details;
    let masg=details.message==="Network Error"?"Error: Please retry later.":this.state.alertMessage;
    return (
      <div style={{ backgroundColor: "#D6EAF880" }} className="container-fluid">
          {details.status==="error"? 
            <Alert 
              message={masg}
              description={details.message}
              type="error"
              showIcon
              banner
            />:
          <>
          {details.status===403?
              <>
                <h1>Your session has expired! Please Login again!</h1>
                <Button type="primary" onClick={this.loginAgain}>OK</Button>
              </>:
              <>
                <h1>We are Sorry, Page Not Found</h1>
                <h3>The page you are looking is Temporary Unavailable. Please try after some time. If this continues please contact team.</h3>
              </> 
          }
          </>
          } 
        </div>
    );
  }
}
export default errorPage;